import request from '@/utils/request';

// 未读消息列表查询
export function mssageCenterList() {
	return request({
		url: '/ocs-project/message/center/list',
		method: 'get',
	})
}

// 消息列表查询
export function messageCenterListAll(query, data){
	return request({
		url: `ocs-project/message/center/list/all${query}`,
		method: 'post',
		data
	})
}

// 标记消息已读
export function messageCenterUpdate() {
	return request({
		url: '/ocs-project/message/center/update',
		method: 'post',
	})
}

// 批量标记消息已读
export function messageCenterBatchUpdate(data){
	return request({
		url: '/ocs-project/message/center/batchUpdate',
		method: 'post',
		data
	})
}